<template>
  <div class="c-nav-dropdown__links nav-with-icon bordered">
    <sc-image v-if="fields && fields.icon" :media="fields.icon" class="c-nav-dropdown__icon" />
    <sc-text
      v-if="fields && fields.heading"
      :field="fields.heading"
      class="c-nav-dropdown__headline"
    />
    <div class="c-link-list" :class="{ 'c-link-list-half': !fields.listFullWidth.value }">
      <sc-placeholder name="jss-link" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Image, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-DropDown-LinkSection-Bordered',
  components: {
    ScText: Text,
    ScImage: Image,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss">
.c-nav-dropdown__half {
  .c-nav-dropdown__links {
    &.bordered {
      border: 1px solid $blue;
      border-radius: 10px;
      padding: 1.5rem 1rem 1.5rem 6rem;
      margin: 0 0 3rem 0;
      @include desktop-up {
        padding: 1.8rem 1rem 1.8rem 9rem;
        margin: 0.8rem 7rem 0 -7rem;
        margin-bottom: auto;
      }
      &.nav-with-icon {
        .c-nav-dropdown__icon {
          padding: 1.8rem 2rem;
          left: 0;
          box-sizing: content-box;
        }
      }
      .c-link-list {
        list-style-type: none;
        padding: 0;
        margin-left: 2rem;
        @include desktop-up {
          margin: auto;
        }
        .c-link-list__item {
          @include desktop-up {
            display: flex;
            margin-top: 0;
          }
          .text-wrap {
            margin-bottom: 1rem;
            @include desktop-up {
              margin-right: 2.5rem;
              margin-bottom: 0;
            }
          }
          .link-wrap {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-right: 3rem;

            .c-button {
              margin-top: 0;

              @include desktop-up {
                float: unset;
                justify-content: center;
              }
            }
          }
          img {
            height: auto;
            box-sizing: content-box;
          }
        }
      }

      .c-link-list {
        @include desktop-up {
          width: 100%;
        }
      }
    }
  }
}
</style>
